import { DataService } from './services/data.service';
import { InstallPromptService } from './services/install-prompt.service';
import { NavigatorComponent } from './navigator/navigator.component';
import { Component, OnInit, Renderer2, OnDestroy, HostListener } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {
  MatBottomSheet,
  MatBottomSheetModule
} from '@angular/material/bottom-sheet';
import { MqttModule } from "ngx-mqtt";
import { CommonModule } from '@angular/common';
import { SwUpdate } from '@angular/service-worker';
import { environment } from '../environment/environment';
import { NotificationService } from './services/notification.service';
import { LockService } from './services/lock.service';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { PinDialogComponent } from './pin-dialog/pin-dialog.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@Component({
    selector: 'app-root',
    imports: [RouterOutlet, MatBottomSheetModule, MatButtonModule, MatIconModule, MqttModule, CommonModule, MatDialogModule, MatProgressSpinnerModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {

  isController: boolean = environment.isController;
  showLoader: boolean = false;

  constructor(private _bottomSheet:MatBottomSheet, private swUpdate: SwUpdate,
    public instalPrompt:InstallPromptService, private toastr: NotificationService, private renderer: Renderer2,
    private lockService: LockService, private dialog: MatDialog, private dataService: DataService){
  }

  ngOnInit(): void {
      if(this.swUpdate.isEnabled){

        this.swUpdate.versionUpdates.subscribe((event:any) => {
          if (event.type === 'VERSION_READY') {
            const currentVersion = event.currentVersion.appData['version'] || 'unknown';
            const latestVersion = event.latestVersion.appData['version'] || 'unknown';
            this.toastr.info(`Current version: ${currentVersion}, Latest version: ${latestVersion}`,'version values')
            this.promptUser();
          }
        });
      }
      if(this.isController){
        this.renderer.addClass(document.body, 'hide-scrollbar');
        this.lockService.startAutoLockTimer();
      }
      this.lockService.isLocked$.subscribe(isLocked => {
        if (isLocked) {
          this.openPinDialog();
        }
      });
      this.dataService.isLoading.subscribe(isLoading=>{
        this.showLoader = isLoading;
      });
  }

  @HostListener('document:click')
  @HostListener('document:keypress')
  @HostListener('document:mousemove')
  @HostListener('document:touchstart')
  onUserActivity() {
    if (this.isController && !this.lockService.getLockState()) {
      this.lockService.resetAutoLockTimer();
    }
  }

  promptUser(): void {
    this.toastr.info(`prompting version update`,'version update')

    const userConfirmed = confirm(
      'A new version of the app is available. Would you like to update?'
    );

    if (userConfirmed) {
      this.applyUpdate();
    }
  }

  applyUpdate(): void {
    this.swUpdate.activateUpdate().then(() => {
      this.clearCacheAndReload();
    });
  }

  openBottomSheet(): void {
    this._bottomSheet.open(NavigatorComponent);
  }


  clearCacheAndReload(): void {
    if ('caches' in window) {
      // Clear the cache
      caches.keys().then((cacheNames) => {
        cacheNames.forEach((cacheName) => {
          caches.delete(cacheName);
        });
      });
    }

    // Reload the page
    document.location.reload();
    window.location.reload();
  }

  ngOnDestroy(){
    if(this.isController){
      this.renderer.removeClass(document.body, 'hide-scrollbar');
    }
  }

  openPinDialog(): void {
    const dialogRef = this.dialog.open(PinDialogComponent, {
      disableClose: true,
      width: '300px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        this.openPinDialog(); // Reopen if not unlocked
      }
    });
  }

}
